var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card mb-4"},[_c('h6',{staticClass:"text-dark font-poppins-semibold",domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('h6',{staticClass:"text-primary font-poppins-semibold pt-3"},[_vm._v(_vm._s(_vm.value))])])])}
var staticRenderFns = []

export { render, staticRenderFns }